import { authorizedGetRequest } from '@/api/requests';

const PLAYERS_BASE = 'profiles';

export const getPlayers = authorizedGetRequest(`${PLAYERS_BASE}/`, {
  ignoreParams: true,
});

const getOrganisationsForInvite = (accessToken, organizationId) =>
  authorizedGetRequest(`/organizations/${organizationId}/admins`, {
    preventCancelRequest: true,
  })(accessToken);
export default {
  getPlayers,
  getOrganisationsForInvite,
};
